import { useEffect } from 'react';
import { Outlet, useNavigate, useMatch } from 'react-router-dom';
import { PermissionDenied, PermissionEnum, IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import {
  useLazyGetExchangeDictionariesQuery,
  useLazyGetCurrenciesExchangeCurrenciesQuery,
  useLazyGetCurrenciesExchangeRateSourcesQuery,
} from '../../store/dictionaries/services';

import ROUTES from '../../routes';

import cn from './echange.module.css';

const Exchange = (): React.JSX.Element => {
  const navigate = useNavigate();

  const match = useMatch(ROUTES.EXCHANGE);

  const { activePermissions, rateSource, currencies, riskScoreRanges } =
    useAppSelector((state) => state.exchangeDictionaries);

  const [getExchangeDictionaries] = useLazyGetExchangeDictionariesQuery();
  const [getCurrenciesExchangeCurrencies] =
    useLazyGetCurrenciesExchangeCurrenciesQuery();
  const [getCurrenciesExchangeRateSources] =
    useLazyGetCurrenciesExchangeRateSourcesQuery();

  useEffect(() => {
    if (
      activePermissions &&
      activePermissions.includes(PermissionEnum.SECTION_EXCHANGE_SETTINGS)
    ) {
      if (!riskScoreRanges) {
        getExchangeDictionaries();
      }

      if (!currencies) {
        getCurrenciesExchangeCurrencies();
      }

      if (!rateSource) {
        getCurrenciesExchangeRateSources();
      }

      if (match) {
        if (
          activePermissions.includes(
            PermissionEnum.SETTINGS_EXCHANGE_MARGINS_LIST,
          )
        ) {
          navigate(ROUTES.MARGINS);
        } else if (
          !activePermissions.includes(
            PermissionEnum.SETTINGS_EXCHANGE_MARGINS_LIST,
          ) &&
          activePermissions.includes(
            PermissionEnum.SETTINGS_EXCHANGE_RATES_LIST,
          )
        ) {
          navigate(ROUTES.RATES);
        }
      }
    }
  }, [match, activePermissions, currencies, rateSource, riskScoreRanges]);

  useEffect(() => {
    let title = 'Exchange';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.exchangeLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions) {
    if (!activePermissions.includes(PermissionEnum.SECTION_EXCHANGE_SETTINGS)) {
      content = <PermissionDenied />;
    } else {
      content = <Outlet />;
    }
  }

  return content;
};

export default Exchange;
